// extracted by mini-css-extract-plugin
export default {"list":"InlineLinkList-module--list--1f803"};